import type { IPaletteItem } from '@repo/web-chrome/components/command-palette/palette-item-types';
import type { ICefrLevelContent } from '@/content/cefr';
import { cefrLevelOrder } from '@/content/cefr';

export function cefrPagesRegistry(content: Record<string, ICefrLevelContent>): IPaletteItem[] {
  const items: IPaletteItem[] = [];
  for (const slug of cefrLevelOrder) {
    const entry = content[slug];
    if (!entry) {
      continue;
    }
    items.push({
      id: `page:cefr-${slug}`,
      group: 'pages',
      title: `${entry.level} · ${entry.label}`,
      subtitle: entry.shortTagline,
      href: `/cefr/${slug}`,
      keywords: [entry.level, slug.toUpperCase(), entry.label, 'cefr'],
      iconName: 'book',
    });
  }
  return items;
}
